<template>
  <div :class="className">
    <div>
      Copyright©2019-2029 上海爱喜衣清洁技术有限公司, All Rights Reserved
      <br /><a href="https://beian.miit.gov.cn/">ICP备案号：沪ICP备11002770号-2</a> |
      <img
        src="../../assets/img/logo-small.png"
        style="height: 20px;  transform: translateY(4px);padding-right: 5px;"
      /><a href="https://beian.mps.gov.cn/#/query/webSearch">沪公网安备：31011202020468号</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: "",
      required: true
    }
  }
};
</script>

<style lang="less" scoped>
.footer {
  position: absolute;
  bottom: 16px;
  text-align: center;
  line-height: 24px;
  color: white;
}
.footer-relative {
  text-align: center;
  line-height: 24px;
}
</style>
